import { useEffect } from 'react';
import { X } from 'lucide-react';

// Click-to-enlarge lightbox. Reuses the app's modal-overlay backdrop so it
// matches existing modals. Click the backdrop or the X to close.
export default function ImageLightbox({ src, alt = '', onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!src) return null;
  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1000 }}>
      <div style={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} aria-label="Close"
          style={{ position: 'absolute', top: -14, right: -14, background: '#fff', border: 'none', borderRadius: '50%', width: 32, height: 32, cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <X size={18} />
        </button>
        {/* width/height auto + a floor keeps vector sources (the default ticket
            SVG) from collapsing to zero here, where nothing gives the image a
            definite size. Raster images are unaffected — they size intrinsically. */}
        <img src={src} alt={alt} style={{ width: 'auto', height: 'auto', minWidth: 280, maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8, background: '#fff' }} />
      </div>
    </div>
  );
}

// Small magnifier button to overlay on a thumbnail without disturbing its own
// click handler. Pass onZoom; it stops propagation.
export function ZoomButton({ onZoom, style }) {
  return (
    <button
      onClick={(e) => { e.stopPropagation(); onZoom(); }}
      title="Enlarge image"
      style={{ position: 'absolute', bottom: 4, right: 4, background: 'rgba(3,30,69,0.72)', color: '#fff', border: 'none', borderRadius: 6, width: 24, height: 24, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, ...style }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
    </button>
  );
}
